import React from 'react';
import FormGroup from './FormGroup';

type FormStaticProps = {
  label: string;
  children: React.ReactNode;
  onClick?: () => void;
  title?: string;
  className?: string;
  extraRowClasses?: string;
  helpContent?: string | React.ReactNode;
};

const FormStatic = ({
  label,
  children,
  onClick,
  title,
  className,
  extraRowClasses,
  helpContent,
}: FormStaticProps) => (
  <FormGroup
    label={label}
    extraRowClasses={extraRowClasses}
    helpContent={helpContent}
  >
    <div
      data-cy={`${label}-form-static`}
      className={`${className || ''
        } form-control-static px-3 flex h-100 w-100 align-items-center`}
      onClick={onClick}
      title={title}
      aria-label={label}
    >
      {children}
    </div>
  </FormGroup>
);
export default FormStatic;
